$(document).ready(function () {
    var scene = $('#text404');
    if (scene.length) new Parallax(scene[0]);
});